'use client'
import { Input } from "@/components/ui/input"

interface PhoneNumberInputProps {
  phoneNumber: string
  setPhoneNumber: (value: string) => void
}

export default function PhoneNumberInput({ phoneNumber, setPhoneNumber }: PhoneNumberInputProps) {
  return (
    <Input
      className="rounded-full border-primary border-[2px] outline-none h-[52px] w-[300px] text-lg focus-visible:ring-0 px-7"
      value={phoneNumber}
      onChange={(evt) => {
        const val = evt.target.value;
        if (/^1\d{0,10}$/.test(val) || val === '') {
          setPhoneNumber(val);
        }
      }}
      placeholder="输入你的手机号..."
    />
  )
}